import api from "./axios-service";

export type InviteSettings = {
  email: string;
  name?: string;
};

export type TeamMember = {
  id: string;
  username: string;
  name: string;
  teamId?: string;
  role: string;
};

export async function inviteMember(data: InviteSettings) {
  const { data: response } = await api.post<TeamMember[]>("/team", data);
  return response;
}

export async function getMembers() {
  const { data: response } = await api.get<TeamMember[]>("/team");
  return response;
}

export async function removeMember(id: string) {
  const { data: response } = await api.delete<TeamMember[]>(`/team/${id}`);
  return response;
}
